<check-in-form-wrapper ariaLabel="{{ 'Verifying payment' | translate:'verifypayment' }}" [step]="'step-6'" [showPriceDisplay]="false">
  <div class="form-wrapper-top-body">
    {{"please-wait-you-are-being-redirected"|translate:"verifypayment"}}
  </div>
</check-in-form-wrapper>
